/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../DashboardCoreAPI'
], (APIFactory, DashboardCoreAPI) => {

	/**
	 * @implements DashboardCoreAPI
	 * @hideconstructor
	 */
	class DashboardCore {

		constructor({ dashboardAPI, internalDashboardAPI }) {
			this._dashboardAPI = dashboardAPI;
			this._internalDashboardAPI = internalDashboardAPI;
			this._api = APIFactory.createAPI(this, [ DashboardCoreAPI ]);
		}

		getAPI() {
			return this._api;
		}

		getFeature(name) {
			return this._dashboardAPI.getFeature(name);
		}

		destroy() {
			const legacyViewControllers = this.getFeature('LegacyViewControllers');
			if(legacyViewControllers) {
				legacyViewControllers.destroy();
			}
			this._internalDashboardAPI.destroy();
		}
	}

	return DashboardCore;
});
